import { Link } from "react-router-dom";
import { Package, Truck, Mail, RotateCcw, ShieldCheck, Clock } from "lucide-react";

const STEPS = [
  {
    icon: Package,
    title: "Traitement sous 24-48h",
    description:
      "Dès que votre paiement est confirmé, votre commande est préparée et expédiée par notre atelier partenaire dans les 24 à 48 heures ouvrées.",
  },
  {
    icon: Truck,
    title: "Livraison sécurisée 5 à 10 jours ouvrés",
    description:
      "Expédition mondiale via transporteurs suivis et assurés. Délai estimé : 5 à 10 jours ouvrés selon votre destination.",
  },
  {
    icon: Mail,
    title: "Numéro de suivi envoyé par email",
    description:
      "Un email de confirmation contenant le numéro de suivi vous est adressé dès l'expédition. Suivez votre colis depuis notre page de suivi.",
  },
  {
    icon: RotateCcw,
    title: "14 jours — satisfaits ou remboursés",
    description:
      "Vous disposez de 14 jours calendaires à réception pour exercer votre droit de rétractation, sans avoir à justifier de motif. Remboursement intégral sous 14 jours après retour du produit.",
  },
];

export default function ShippingReturns() {
  return (
    <div data-testid="shipping-returns-page">
      <section className="border-b border-white/10">
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-20">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#C5CDD8]">
            Service client
          </div>
          <h1 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-white">
            Livraison &amp; Retours
          </h1>
          <p className="mt-6 text-base sm:text-lg text-white/70 max-w-2xl leading-relaxed">
            Notre engagement : la simplicité. De votre commande à la réception
            de votre colis, et même pour un retour, chaque étape est pensée
            pour être limpide.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-12">
          {STEPS.map((s, i) => (
            <div
              key={i}
              className="border-t border-white/10 pt-8"
              data-testid={`shipping-step-${i}`}
            >
              <div className="flex items-baseline gap-4">
                <span className="font-display text-2xl font-bold text-[#C5CDD8]">
                  0{i + 1}
                </span>
                <s.icon size={22} strokeWidth={1.25} className="text-[#C5CDD8]" />
              </div>
              <h2 className="font-display mt-4 text-2xl sm:text-3xl font-bold uppercase tracking-tighter text-white">
                {s.title}
              </h2>
              <p className="mt-4 text-sm sm:text-base text-white/70 leading-relaxed">
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#0A2A4F] border-y border-white/10">
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-8">
          {[
            {
              i: ShieldCheck,
              t: "Frais de livraison",
              d: "Offerte dès $75 d'achat. $4.90 en deçà.",
            },
            {
              i: Clock,
              t: "Adresse de retour",
              d: "Notre atelier partenaire. Étiquette communiquée par email après demande à nordstellatech@gmail.com.",
            },
            {
              i: Mail,
              t: "Une question ?",
              d: "Notre équipe répond sous 48h ouvrées via le formulaire de contact.",
            },
          ].map((v, i) => (
            <div key={i} className="flex items-start gap-4">
              <v.i size={22} strokeWidth={1.25} className="text-[#C5CDD8]" />
              <div>
                <div className="font-display text-lg font-bold tracking-tight text-white">{v.t}</div>
                <div className="text-sm text-white/60 mt-1 leading-relaxed">{v.d}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-12 py-20 text-center">
        <h3 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tighter text-white">
          Besoin de suivre votre commande ?
        </h3>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link
            to="/tracking"
            className="border border-white bg-white text-[#001F3F] hover:bg-transparent hover:text-white transition-all uppercase tracking-[0.25em] text-xs font-bold px-8 py-4"
            data-testid="shipping-cta-tracking"
          >
            Suivre ma commande
          </Link>
          <Link
            to="/contact"
            className="border border-white/40 bg-transparent text-white hover:bg-white hover:text-[#001F3F] transition-all uppercase tracking-[0.25em] text-xs font-bold px-8 py-4"
          >
            Nous écrire
          </Link>
        </div>
        <p className="mt-6 text-xs text-white/60">
          Conditions complètes :{" "}
          <Link to="/legal/cgv" className="underline hover:text-white">
            Consultez nos CGV
          </Link>
          .
        </p>
      </section>
    </div>
  );
}
